/**
 * Layout constants for floating UI elements
 *
 * Manages positioning and z-index hierarchy for:
 * - Support button (bottom-right, always visible)
 * - Floating toolbar (bottom-right, shows on scroll)
 * - Toast notifications (top-right, no conflict with bottom elements)
 */

export const FLOATING_ELEMENTS = {
  SUPPORT: {
    HEIGHT: 56, // Support button height
    BOTTOM: 24, // Bottom margin from viewport
    RIGHT: 24, // Right margin from viewport
    Z_INDEX: 1000,
  },
  TOOLBAR: {
    HEIGHT: 68, // Approximate height, measured dynamically when visible
    BOTTOM: 24, // Bottom margin from viewport when visible
    GAP: 8, // Gap between toolbar and support button when both visible
    Z_INDEX: 1100,
  },
} as const;

/**
 * Z-index hierarchy for all UI layers
 * Use these constants to ensure consistent stacking order
 */
export const Z_INDEX = {
  SUPPORT_BUTTON: FLOATING_ELEMENTS.SUPPORT.Z_INDEX, // 1000
  FLOATING_TOOLBAR: FLOATING_ELEMENTS.TOOLBAR.Z_INDEX, // 1100
  MODAL_BACKDROP: 1200,
  MODAL: 1300,
  TOAST: 1400, // notistack default
  TOOLTIP: 1500,
} as const;
